import React, { useState} from 'react'


export default function Pagination({handlePageChange, total, page}) {

  
  let [num, setNum] = useState(1) 
  let [curr, setCurr] = useState(1)

  let defaultValues = [];
  for(let i = 0; i < page; i++){
    defaultValues.push({pageNum : i + 1})
  }
  

  
  const next = () =>{
    if(!(num >= page)){
      setNum(++num)
      setCurr(num)
      let body ={
        skip : (num - 1) * 25,
        limit : 25
      }
      handlePageChange(body)
    }
  }


  const Previous = () =>{
    if((num > 1)){ 
      num >= 2  && setNum(--num) 
       setCurr(num)
      let body = {
        skip : (num - 1) * 25,
        limit : 25
      }
       handlePageChange(body)
    }
  }


  const handleSelect = (pageNum) =>{
    setNum(pageNum)
    setCurr(pageNum)
    
    let body ={
      skip : (pageNum - 1) * 25,
      limit : 25
    }  
    handlePageChange(body)
  }
  
 

  
  return (
  <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
    <div className="flex flex-1 justify-between sm:hidden">
      <a
        href=""
        className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
      >
        Previous
      </a>
      <a
        href="#"
        className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
      >
        Next
      </a>
    </div>
    <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
      <div>
        <p className="text-sm text-gray-700">
          Showing <span className="font-medium">{total ? num > 0 && (num - 1) * 25  : 0}</span> to <span className="font-medium">{total ? num  * 25 : 0}</span> having total{' '}
          <span className="font-medium">{total??0}</span> results
        </p>
      </div>
      <div>
        <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
          <button
            onClick={Previous}
            className="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
          >
            <span className="sr-only">Previous</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>

          </button>

          {/* Current: "z-10 bg-indigo-50 border-indigo-500 text-indigo-600", Default: "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" */}
         
          {defaultValues.map((val, i)=>(
            <button
            onClick={()=>handleSelect(val?.pageNum) }
            key={i}
            // aria-current="page"
            className={`relative inline-flex items-center border px-4 py-2 text-sm font-medium focus:z-20 ${curr === val?.pageNum ? " bg-indigo-50 border-indigo-500 text-indigo-600" : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" }` }
          >
            {val?.pageNum}
          </button>

          ))}
          
          <button
            onClick={next}
            className="relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
          >
            <span className="sr-only">Next</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
            </svg>

          </button>
        </nav>
      </div>
    </div>
  </div>
  )
}
